import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ForemanActionsBarContext } from '../../../../components/HostDetails/ActionsBar';
import BulkDisassociateModal from './BulkDisassociateModal';

const BulkDisassociateModalScene = ({ isOpen, closeModal }) => {
  const {
    selectAllHostsMode,
    selectedCount,
    selectedResults,
    fetchBulkParams,
    bulkScopeHash,
  } = useContext(ForemanActionsBarContext);
  return (
    <BulkDisassociateModal
      key="bulk-disassociate-modal"
      selectAllHostsMode={selectAllHostsMode}
      selectedCount={selectedCount}
      selectedResults={selectedResults}
      fetchBulkParams={fetchBulkParams}
      bulkScopeHash={bulkScopeHash}
      isOpen={isOpen}
      closeModal={closeModal}
    />
  );
};

export default BulkDisassociateModalScene;

BulkDisassociateModalScene.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};
